// extracted by mini-css-extract-plugin
export default {"headerNav":"SharedLayout_headerNav__jce2m","nav":"SharedLayout_nav__PnhXR","iconCard":"SharedLayout_iconCard__IONtM","countDish":"SharedLayout_countDish__dqdOK"};